import * as React from "react";
import { Viewport, ViewMedium, ViewSmall } from "bernie-view";
import { UitkIconSize, UitkIcon } from "uitk-react-icons";
import { gtConfig } from "src/stores/wizard/config/staticConfigs/car/gt/gtConfig";
import { useLocalization } from "@shared-ui/localization-context";

export const SwapLocations = ({ swapLocations }: { swapLocations: () => void }) => {
  const { formatText } = useLocalization();
  const switchA11yText = formatText(gtConfig.switchLocKey);

  return (
    <>
      <Viewport>
        <ViewMedium>
          <button className="SwapLocationsDesktop" onClick={swapLocations} type="button" aria-label={switchA11yText}>
            <UitkIcon name="swap_vert" id="swapLocations" size={UitkIconSize.MEDIUM} />
          </button>
        </ViewMedium>
        <ViewSmall>
          <button className="SwapLocations" onClick={swapLocations} type="button" aria-label={switchA11yText}>
            <UitkIcon className="all-l-padding-half" name="swap_vert" id="swapLocations" size={UitkIconSize.MEDIUM} />
          </button>
        </ViewSmall>
      </Viewport>
    </>
  );
};
